import { useUserStore } from '@bv/stores/user';
import { computed } from 'vue';

import type { RoleDependencies } from '@bv/features/settings/roles/types/dependencies';

export const MODULES_ORDER_ARRAY: readonly string[] = [
  'call-center',
  'ai-call-center',
  'reports',
  'campaigns',
  'call-evaluation',
  'settings',
];

const campaignDependencies = computed<string[]>(() => {
  const dependencies = ['read-webphone', 'read-ivrs', 'read-queues'];
  if (useUserStore().callCenterService?.settings.ai_service.enabled) {
    dependencies.push('read-ai-agents');
  }
  return dependencies;
});

export const PERMISSION_DEPENDENCIES: RoleDependencies = {
  'write-users': ['read-extensions', 'read-roles-&-permissions'],
  'update-users': ['read-extensions', 'read-roles-&-permissions'],
  'write-queues': ['read-announcements', 'read-sound-on-hold'],
  'update-queues': ['read-announcements', 'read-sound-on-hold'],
  'write-announcements': ['read-recordings'],
  'update-announcements': ['read-recordings'],
  'write-ivrs': ['read-recordings'],
  'update-ivrs': ['read-recordings'],
  'write-time-conditions': ['read-time-groups'],
  'update-time-conditions': ['read-time-groups'],
  'write-teams': ['read-users'],
  'update-teams': ['read-users'],
  'write-campaigns': campaignDependencies,
  'update-campaigns': campaignDependencies,
};
